import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.6.5_@types+node@18.16.19_eslint@8.45.0_typescript@5.1.6/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}